module.exports = __webpack_public_path__ + "static/page-header-1-1-09ba8d4eb0967d9ae2bdfd8e403218da.jpg";